<script>
import VTooltipWrapper from "../../../../common/v-tooltip-wrapper.vue";
import CalendarEvent from "./CalendarEvent";

export default {
    name: "calendar-event-all-day-icon",
    components: {VTooltipWrapper},
    props: {
        event: CalendarEvent
    },
    computed: {
        text() {
            return Lang.langGet('This event is scheduled for the whole day');
        }
    }
}
</script>

<template>
    <v-tooltip-wrapper v-if="event.allDay && event.isInMonthView && !event.isBackgroundEvent">
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="calendar-all-day">
                {{ '24h' }}
            </span>
        </template>
        <div class="icon-in-tooltip-container">
            {{ text }}
        </div>
    </v-tooltip-wrapper>
</template>

<style lang="scss" scoped>
.calendar-all-day {
    display: flex;
    align-items: center;
    font-weight: bold;
    justify-content: center;
    transition: color 0.3s ease-out;
    color: inherit;
    z-index: 1;
}
</style>
